export const ADMIN_AFFILIATE_TRACKERS_SETTINGS_TRACKERS_DEAL_MAIN_ROUTE_NAME = Symbol('admin.affiliates.approved.trackers-settings.trackers.main-deal-changes');
export const ADMIN_AFFILIATE_TRACKERS_SETTINGS_TRACKERS_DEAL_CHANGES_ROUTE_NAME = Symbol('admin.affiliates.approved.trackers-settings.trackers.deal-changes');

export const AFFILIATE_CURRENT_TRACKER_UPDATE_MUTATION = 'affiliate.update-current-tracker';
export const AFFILIATE_CURRENT_TRACKER_UPDATE_API_URL = 'admin/affiliates/:id/trackers/:trackerId/update_condition';

export const AFFILIATE_TRACKER_HISTORY_DELETE_MUTATION = 'affiliate.delete-history-tracker';
export const AFFILIATE_TRACKER_HISTORY_DELETE_API_URL = 'admin/history_of_trackers_changes/:itemId';
